<template>
  <a-modal
    :title="title"
    v-model="modalShow"
    width="60%"
    @cancel="close"
    :footer="null"
    destroyOnClose
  >
    <a-form-model
      v-if="dialogType != 'detail'"
      class="common-form-inline"
      ref="ruleForm"
      :model="pageData"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 13 }"
    >
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-model-item label="附件类型" prop="fileTpCd ">
            <a-radio-group v-model="pageData.fileTpCd">
              <a-radio
                v-for="item in fileTypeList"
                :key="item.value"
                :value="item.value"
                >{{ item.name }}</a-radio
              >
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="附件上传" prop="fileId">
            <div style="position:relative">
              <fileUpload
                accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF"
                ref="fileUpload"
                :paramObj.sync="uploadParam"
                @uploadOk="uploadOk"
                name="file"
              />
              <div class="text-color-orange img-tip">
                注：附件支持图片及pdf格式，且大小不可超过30M
              </div>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="table-common common">
      <a-table
        :loading="tableLoading"
        size="middle"
        :columns="columns"
        :row-key="record => record.id"
        :data-source="tableData"
        :pagination="false"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >
        <template slot="fileTpCd" slot-scope="text">
          {{ text | dictFilter(dict.fileTpCd) }}
        </template>
        <template slot="createTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="oper" slot-scope="text, record, index">
          <span
            class="text-color-red pointer"
            v-if="dialogType != 'detail'"
            @click="delFun(record, index)"
            >撤销</span
          >
          <a @click="downloadFile(record)">下载附件</a>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { fileSaveAPI, fileQueryAPI, fileDeletAPI } from "@/api/file.js";
import { mapActions } from "vuex";
export default {
  props: {
    info: {
      type: [Object],
      default: function() {
        return {};
      }
    }
  },
  components: {},
  name: "invoice-info-dialog",
  data() {
    return {
      titleMap: {
        add: "相关附件-上传",
        edit: "相关附件-编辑",
        detail: "相关附件-查看"
      },
      title: "相关附件-上传",
      dialogType: "add",
      invData: {},
      invDataList:[],
      readonly: false,
      modalShow: false,
      tableLoading: false,
      tableData: [],
      uploadParam: {
        app: "portal-pc",
        module: "payable",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: "payable"
      },
      fileTypeList: [
        {
          name: "发票明细",
          value: "4"
        },
        {
          name: "其他",
          value: "5"
        }
      ],
      pageData: {
        file: null,
        fileId: undefined,
        fileTpCd: "4"
      },
      columns: [
        {
          title: "附件名称",
          dataIndex: "fileNm"
        },
        {
          title: "附件类型",
          dataIndex: "fileTpCd",
          scopedSlots: { customRender: "fileTpCd" }
        },
        {
          title: "上传人",
          dataIndex: "createUser"
        },
        {
          title: "上传日期",
          dataIndex: "createTime",
          scopedSlots: { customRender: "createTime" }
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" }
        }
      ],
      fileReadonly: false
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    })
  },
  created() {},
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    open({ invData, invDataList, dialogType, voucherList }) {
      /**
       * @params{dialogType} add\edit\detail
       */
      this.dialogType = dialogType || "add";
      this.title = this.titleMap[dialogType];
      this.invData = this.utils.deepClone(invData || {});
      this.invDataList = this.utils.deepClone(invDataList || {});
      this.readonly = dialogType == "add" ? false : true;
      this.modalShow = true;
      if (dialogType != "add") {
        this.getTableList();
      }
    },
    close() {
      this.pageData = {
        file: null,
        fileId: undefined,
        fileTpCd: "4"
      };
      this.tableData = [];
      this.modalShow = false;
    },
    getTableList() {
      this.tableLoading = true;
      fileQueryAPI({
        expdId: this.invData.cyCode
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data || [];
        })
        .catch(err => {
          console.log(err);
        });
    },
    uploadOk(resList) {
      this.fileSave(resList[0]);
    },
    fileSave(data) {
      let inItem = this.tableData.find(i => i.fileNm == data.name);
      if (inItem) {
        this.$message.warn("附件已在列表中，不可重复提交");
        this.$refs.fileUpload.setFileList();
        return;
      }
      // const param = {
      //   fileNm: data.name,
      //   fileSize: data.size,
      //   fileRte: data.fileRte,
      //   fileExpdNm: data.fileExpdNm,
      //   tblBlId: this.uploadParam.tblBlId,
      //   mdlId: "payable",
      //   expdId: this.invData.cyCode,
      //   fileTpCd: this.pageData.fileTpCd,
      //   fileSubTpCd: 0
      // };
      // fileSaveAPI(param)
      //   .then(res => {
      //     this.uploading = false;
      //     this.$refs.fileUpload.setFileList();
      //     this.$message.success("上传成功");
      //     this.$emit("save");
      //     this.getTableList();
      //   })
      //   .catch(err => {
      //     this.uploading = false;
      //     console.log(err);
      //   });
      let httpList = [];
      this.invDataList.forEach(i => {
        const param = {
          fileNm: data.name,
          fileSize: data.size,
          fileRte: data.fileRte,
          fileExpdNm: data.fileExpdNm,
          tblBlId: this.uploadParam.tblBlId,
          mdlId: "payable",
          expdId: i.cyCode,
          fileTpCd: this.pageData.fileTpCd,
          fileSubTpCd: 0
        };
        httpList.push(this.batchSave(param));
        Promise.all(httpList).then(res => {
          this.uploading = false;
          this.$refs.fileUpload.setFileList();
          this.$message.success("上传成功");
          this.$emit("save");
          this.getTableList();
        }).catch(err => {
          console.log(err);
        })
      })
    },
    batchSave(param){
      return new Promise((resolve,reject) => {
        fileSaveAPI(param)
        .then(res => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
      })
    },
    delFun(record, index) {
      const self = this;
      this.$confirm({
        title: "撤销",
        content: "您正在进行撤销操作，是否确认？",
        onOk() {
          fileDeletAPI({
            fileRte: record.fileRte,
            fileNm: record.name,
            fileExpdNm: record.fileExpdNm,
            fileSize: record.fileSize,
            tblBlId: record.tblBlId,
            fileId: record.fileId,
            fileTpCd: record.fileTpCd,
            fileSubTpCd: record.fileSubTpCd,
            expdId: record.expdId
          }).then(res => {
            self.$message.success("撤销成功");
            self.tableData.splice(index, 1);
            self.$emit("save");
          });
        },
        onCancel() {}
      });
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    }
  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
  position: absolute;
  left: 120px;
  font-size: 12px;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/receivable/related-file-dialog.vue